import React from 'react';
import { AppBar, Toolbar, Button, Typography, Container, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import ClientAcquisitionCard from '../../components/landingpage/ClientAcquisitionCard';
import PortfolioRetentionCard from '../../components/landingpage/PortfolioRetentionCard';
import LandingSection from '../../components/landingpage/LandingSection';
import ConsumerEngagementCard from '../../components/landingpage/ConsumerEngagementCard';
import ExclusiveLeadsComponent from '../../components/landingpage/ExclusiveLeads';
import GetStartedCard from '../../components/landingpage/GetStarted';

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontSize: theme.typography.pxToRem(15),
  marginX: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
    boxShadow: 'none',
  },
  padding: theme.spacing(1, 2),
  border: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(18), // Larger text on bigger screens
  },
}));

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <>
      <LandingPageNav/>
      <Container maxWidth="lg"> {/* Adjust maxWidth for different screen sizes */}
        <Grid container spacing={4} direction="column">
          <Grid item xs={12}>
            <LandingSection />
          </Grid>
          {/* Adjust grid item sizes for different breakpoints */}
          <Grid item xs={12} sm={6} md={4}>
            <ConsumerEngagementCard />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <ClientAcquisitionCard />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <PortfolioRetentionCard />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <ExclusiveLeadsComponent />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <GetStartedCard />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
